import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import tokens from "@/theme/harvest.json";
import { ChatPanel } from "@/components/chat/ChatPanel";
import { http } from "@/lib/api";

const parentHost = () => {
  const origin = window.location.ancestorOrigins?.[0] || document.referrer;
  try {
    return new URL(origin).hostname;
  } catch {
    return "";
  }
};

const useHostAllowed = () => {
  const [allowed, setAllowed] = useState(null);
  useEffect(() => {
    if (window.parent === window) return setAllowed(true);
    const host = parentHost();
    if (host === window.location.hostname) return setAllowed(true);
    http.get("/embed/check", { params: { host } }).then((r) => setAllowed(r.data.allowed)).catch(() => setAllowed(false));
  }, []);
  return allowed;
};

const closeFrame = () => window.parent.postMessage({ type: "ceres:close" }, "*");

export default function EmbedPage() {
  const [params] = useSearchParams();
  const brand = params.get("brand") === "hhis" ? "hhis" : "etf";
  const lang = params.get("lang") === "fr" ? "fr" : "en";
  const ticker = params.get("ticker");
  const page = { brand, ticker: ticker ? ticker.toUpperCase() : null, path: params.get("from") || "/", theme: tokens.themes[brand] };

  const allowed = useHostAllowed();
  if (allowed === null) return <div className="h-screen bg-white" data-testid="embed-checking" />;
  if (!allowed) {
    return (
      <div className="flex h-screen items-center justify-center bg-white p-6 text-center text-sm text-hv-muted" data-testid="embed-not-allowed">
        Ceres isn't available on this website.
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col bg-white" data-testid="embed-page">
      <ChatPanel page={page} theme={page.theme} onClose={closeFrame} initialLang={lang} />
    </div>
  );
}
